import React from "react";
import {WizTableForm} from '@/containers/common';

import moment from "moment";

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}
const organization = WizTableForm.Config.organization(this, {apiParams: {state: 1}})
const user = WizTableForm.Config.user(this, {apiParams: {state: 1}});
const position = WizTableForm.Config.position(this, {apiParams: {state: 1}})
//配置项
const componentName = "examEveryday";

function columns() {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: "组织名称",
      name: "orgIdList",
      searchItem: {
        ...organization,
        diy: WizTableForm,
      },
    },
    {
      title: "学员",
      name: "personIdList",
      searchItem: {
        ...user,
        diy: WizTableForm,
      },
    },
    {
      title: "岗位",
      name: "positionIdList",
      searchItem: {
        ...position,
        diy: WizTableForm
      },
    },
    {
      title: "状态",
      name: "pass",
      searchItem: {
        type: "select"
      },
      dict: [
        {code: 0, codeName: '未通过'},
        {code: 1, codeName: '通过'},
      ]
    },


    {
      title: "学员姓名",
      name: "fullName",
      tableItem: {},
    },
    {
      title: '学员账号',
      name: 'userName',
      tableItem: {},
    },
    {
      title: '组织名称',
      name: 'orgName',
      tableItem: {
        render: (text, record) => {
          const {orgName,orgCode,orgNodeTypeName,parentOrgCode,parentOrgName} =record;
          let showText = orgNodeTypeName ===null || orgNodeTypeName !=='新能源组' ? orgName :parentOrgName;
          return showText
        }
      }
    },
    {
      title: '组织编号',
      name: 'orgCode',
      tableItem: {
        render: (text, record) => {
          const {orgName,orgCode,orgNodeTypeName,parentOrgCode,parentOrgName} =record;
          let showText = orgNodeTypeName ===null || orgNodeTypeName !=='新能源组' ? orgCode :parentOrgCode;
          return showText
        }
      }
    },
    {
      title: "岗位",
      name: "positionName",
      tableItem: {},
    },
    {
      title: "参加考试时间",
      name: "markingDate",
      tableItem: {
        render: (text) => {
          return formatterDate(text)
        }
      },
    },
    {
      title: "成绩",
      name: "score",
      tableItem: {},
    },
    {
      title: "状态",
      name: "pass",
      tableItem: {},
      dict: [
        {code: 0, codeName: '未通过'},
        {code: 1, codeName: '通过'},
        {code: 2, codeName: '未参与'},
      ]
    }
  ];
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ],
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            return value
          }
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          isScroll: true,
          loading: false,
        }
      },
    },
  };
}

const _apis = (data) => {
  const {examId} = data;
  return {
    list: {
      path: `${componentName}/pageList`,
      payload: {
        key: `${componentName}@pageList`,
        apiParams: {pageNum: 1, pageSize: 10, examId: examId ? examId : null},
      },
    },
    export: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {examId: examId ? examId : null}
      }
    }
  }
}

let reduxTemplateCofig = (args) => {
  const {examId} = args;
  return {
    apis: _apis({examId}),
    componentName,
    initApiKeys: ["list"],
    keepInitApiParams: true,
    needLoading: true,
    ...args,
  };
};

export {reduxTemplateCofig, templateConfig};
